import { ChangeRequestResultPage, cs } from "@repo/ui";
import { type FC } from "react";

export type IChangeRequestConfirmation = {
    heading?: string;
    description?: string;
    attention?: string;
    documentsAttentionOverride?: string | null;
};

const ChangeRequestConfirmation: FC<IChangeRequestConfirmation> = ({
    heading,
    description = cs.changeRequestResult.processing.body,
    documentsAttentionOverride,
    attention,
}) => {
    return (
        <ChangeRequestResultPage
            status="success"
            titleOverride={heading}
            bodyText={description}
            bodyVariant="plain"
            documentsBanner={documentsAttentionOverride}
            attention={attention}
        />
    );
};

export default ChangeRequestConfirmation;
